import './GoogleAccessPolicy.scss';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useGoogleLogin } from '@react-oauth/google';
import google from '../../assets/images/google-g.png';
import privacyInfoIcon from '../../assets/images/privacyInfo.svg';
import Loader from '../../components/Loader/Loader';
import { useGoogleAccessPolicyProvider } from '../../providers/GoogleAccessPolicyProvider';

const GoogleAccessPolicy = () => {
    const googleAccessPolicyContext = useGoogleAccessPolicyProvider();
    const { t } = useTranslation();
    const [authCode, setAuthCode] = useState('');
    const [notification, setNotification] = useState('');
    const PRIVACY_POLICY_URL = 'https://ac-myaccess-'+process.env.REACT_APP_PRIVACY_POLICY_ENV+'-ingestiondata.s3.ca-central-1.amazonaws.com/PrivacyStatement/my+ACcess+-+Sync+to+Calendar+Privacy+Policy_v1.0.pdf';

    useEffect(() => {
        if(!authCode) return;
        googleAccessPolicyContext.getCalendarSyncStatus(authCode);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [authCode])

    useEffect(() => {
        if(!googleAccessPolicyContext.statusMessage) return;
        setNotification(googleAccessPolicyContext.statusMessage);

    }, [googleAccessPolicyContext.statusMessage])

    const handleOnClickPrivacyPolicy = () => {
        window.open(PRIVACY_POLICY_URL, '_blank');
    }

    const handleOnClickBtnGoogleSignin = useGoogleLogin({
        onSuccess: (credentialResponse) => { setAuthCode(credentialResponse.code) },
        flow: 'auth-code',
        ux_mode: 'popup',
        scope: 'https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/calendar https://www.googleapis.com/auth/userinfo.profile openid',
    });

    return (
        googleAccessPolicyContext.loading ? <Loader /> :
        <div className="c-google-access-policy">
            <div className="c-title">
                <h1>{t('googleAccessPolicy.title')}</h1>
            </div>
            <div className="c-info">
                <span>{t('googleAccessPolicy.titleDescription')}</span>
                <p className="label-description">{t('googleAccessPolicy.description')}</p>
                <div className="btn-google" onClick={handleOnClickBtnGoogleSignin}>
                    <img className='google-icon' src={google} alt='google' />
                    <div className='google-text'>{t('googleAccessPolicy.loginWithGoogle')}</div>
                </div>
                {notification === 'One or more pilot profiles is mapped to this email address' && (
                    <div className='notification-access-policy notification-access-policy--success'> 
                        <i className='icon-Confirmation-circle icon--access-policy icon-Confirmation-circle--access-policy'></i>
                        <span className="label-notification">{notification}</span>
                    </div>
                )}
                {notification === 'No pilot profile is mapped to this email address' && (
                    <div className='notification-access-policy notification-access-policy--error'> 
                        <i className='icon-Error-warning icon--access-policy icon-Error-warning--access-policy'></i>
                        <span className="label-notification">{notification}</span>
                    </div>
                )}
                
                <p style={{marginTop: notification ? '2.2rem' : '3.4rem'}}>{t('googleAccessPolicy.homepage')}</p>
                <p className="label-header">{t('googleAccessPolicy.header1')}</p>
                <p className="label-homepage-description">{t('googleAccessPolicy.homepageDescription1')}</p>

                <p className="label-header">{t('googleAccessPolicy.header2')}</p>
                <p className="label-homepage-description">{t('googleAccessPolicy.homepageDescription2')}</p>

                <p className="label-header">{t('googleAccessPolicy.header3')}</p>
                <p className="label-homepage-description">{t('googleAccessPolicy.homepageDescription3')}</p>

                <p className="label-header">{t('googleAccessPolicy.header4')}</p>
                <p className="label-homepage-description">{t('googleAccessPolicy.homepageDescription4')}</p>

                <div className="c-privacy-policy">
                    <img alt="privacyIcon" src={privacyInfoIcon} />
                    <span className="label-privacy-policy" onClick={handleOnClickPrivacyPolicy}>{t('googleAccessPolicy.privacyPolicy')}</span>
                </div>
            </div>
        </div>
    )
}

export default GoogleAccessPolicy;
